class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.closeTimer = null;
    this.openTimer = null;
    this.onHoverOpen = this.onHoverOpen.bind(this);
    this.onHoverClose = this.onHoverClose.bind(this);
    this.onSummaryClick = this.onSummaryClick.bind(this);

    this.mediaQuery = window.matchMedia('(min-width: 990px)');
    this.bindHover(this.mediaQuery.matches);
    if (this.mediaQuery.addEventListener) {
      this.mediaQuery.addEventListener('change', (event) => this.bindHover(event.matches));
    } else if (this.mediaQuery.addListener) {
      this.mediaQuery.addListener((event) => this.bindHover(event.matches));
    }

    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) {
      summary.addEventListener('click', this.onSummaryClick);
    }
  }

  bindHover(enable) {
    this.removeEventListener('mouseenter', this.onHoverOpen);
    this.removeEventListener('mouseleave', this.onHoverClose);
    if (enable) {
      this.addEventListener('mouseenter', this.onHoverOpen);
      this.addEventListener('mouseleave', this.onHoverClose);
    }
  }

  onSummaryClick(event) {
    // Desktop: hover opens the menu; keep first click from immediately closing it
    if (this.mediaQuery.matches) {
      event.preventDefault();
      if (!this.mainDetailsToggle.hasAttribute('open')) {
        this.openMenu();
      }
    }
  }

  onHoverOpen() {
    if (!this.mediaQuery.matches) return;
    clearTimeout(this.closeTimer);
    clearTimeout(this.openTimer);
    this.openTimer = setTimeout(() => this.openMenu(), 60);
  }

  onHoverClose() {
    if (!this.mediaQuery.matches) return;
    clearTimeout(this.openTimer);
    this.closeTimer = setTimeout(() => {
      this.close();
      if (this.header) this.header.preventHide = false;
    }, 120);
  }

  openMenu() {
    document.querySelectorAll('header-menu details[open]').forEach((details) => {
      if (details !== this.mainDetailsToggle) {
        details.removeAttribute('open');
        const summary = details.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      }
    });

    this.mainDetailsToggle.setAttribute('open', '');
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'true');
    this.onToggle();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
